export default __webpack_public_path__ + "484cc589a0cb4c4dc88c27ddc057565c.svg";